import { CustomLink, LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { createDataTable } from 'components/DataTable';
import React, { useState } from 'react';
import { getProjectUnits, getProjectUnitsExportUrl } from 'services/projects';
import { BygrProject, ProjectUnit } from 'types';
import { useAsyncStateWithIsLoading } from 'utils/hooks';
import { showModules } from 'utils/util';

// import theme from './ProjectUnits.module.scss';

interface ProjectUnitsProps {
    project: BygrProject;
}
const DataTable = createDataTable<ProjectUnit>();

const ProjectUnits: React.FC<ProjectUnitsProps> = ({ project }) => {
    const [tableState, setTableState] = useState(DataTable.getInitialState('id'));

    const [data, , , isLoading] = useAsyncStateWithIsLoading(
        () => getProjectUnits(project.id, tableState),
        [project.id, tableState],
        null
    );
    if (!data) return <LoadingIndicator />;
    return (
        <>
            <DataTable
                exportUrl={getProjectUnitsExportUrl(project.id, tableState)}
                hasSearchField
                isLoading={isLoading}
                data={data.items}
                onStateChange={setTableState}
                state={tableState}
                totalItemCount={data.totalCount}
                className="table style-3">
                <DataTable.Column
                    header="Id"
                    field="id"
                    sortable
                    renderer={({ row, value }) => <CustomLink to={`units/${row.id}`}>{value}</CustomLink>}
                />
                <DataTable.Column header="Name" field="name" sortable />
                <DataTable.Column
                    header="Buyers"
                    field="buyers"
                    renderer={({ value }) => <>{value.map((b) => b.name).join(', ')}</>}
                />
                <DataTable.Column
                    header="Seller module"
                    field="sellerModule"
                    sortable
                    renderer={({ value }) => showModules(value)}
                />
                <DataTable.Column
                    header="Buyer module"
                    field="buyerModule"
                    sortable
                    renderer={({ value }) => showModules(value)}
                />
            </DataTable>
        </>
    );
};

export default ProjectUnits;
